import React from 'react';
import {
  Box,
  Button,
  ButtonProperties,
  Modal,
  Text,
} from '@nimbus-ds/components';
import { useTranslationCommon } from 'commons/hooks';

interface ModalConfirmationBaseNewProps {
  show: boolean;
  title?: string;
  text?: React.ReactElement | string;
  label?: string;
  labelCancel?: string;
  appearance?: ButtonProperties['appearance'];
  onConfirm: () => void;
  onCancel: () => void;
  disabled?: boolean;
}

export function ModalConfirmationBaseNew({
  show,
  title,
  text,
  label,
  disabled,
  labelCancel,
  appearance,
  onConfirm,
  onCancel,
}: ModalConfirmationBaseNewProps): JSX.Element {
  const t = useTranslationCommon();

  return (
    <Modal open={show} onDismiss={onCancel}>
      <Box display="flex" flexDirection="column" gap="4">
        <Text fontSize="highlight" fontWeight="bold" color="neutral-textHigh">
          {title || t('common:exitEdit.title')}
        </Text>
        {['string', 'undefined'].includes(typeof text) ? (
          <Text fontSize="base">{text || t('common:exitEdit.info')}</Text>
        ) : (
          text
        )}
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          justifyContent="flex-end"
          gap="2"
        >
          <Button onClick={onCancel}>
            {labelCancel || `${t('common:exitEdit.continue')}`}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={disabled}
            appearance={appearance || 'danger'}
          >
            {label || `${t('common:exitEdit.confirm')}`}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
